/**
 * @module oauth/fetchConfig
 *
 * @fileOverview A simple wrapper to GET `/apiUrl/config` with the appropriate
 * Authorization header, so we can fetch the config stored in the backend. This
 * is primarily used by Mission Control to determine whether some features of
 * the app are enabled in the current environment.
 */

import request from './request'

export default function fetchConfig() {
  return request.get('/config')
}
